<template>
    <div class="detail-wrapper">
        <div v-if="banner && banner.length" class="detail-wrapper-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)">
        </div>
        <div class="detail-wrapper-body">
            <div class="works-detail">
                <main class="works-detail__content">
                    <div class="works-detail__content-head">
                        <div class="wdc-head__title">
                            <div class="wdc-head__title-tag">
                                <svg-icon icon-class="recommend0" class-name="icon-recommend0" v-if="recommend === 1"></svg-icon>
                                <svg-icon icon-class="recommend2" class-name="icon-recommend2" v-else-if="recommend === 2"></svg-icon>
                            </div>
                            <span>{{ title }}</span>
                            <router-link target="_blank" :to="`/material/detail/${materialId}`" v-if="materialId" class="to-material">
                                点此购买同款
                                <img src="../../../assets/images/arrow-left.png" alt="">
                            </router-link>
                        </div>
                        <div class="wdc-head__action">
                            <div class="wdc-head__action-item">
                                <svg-icon icon-class="follow" class-name="icon-follow"></svg-icon>
                                <span>{{ follow }}</span>
                            </div>
                            <div class="wdc-head__action-item">
                                <svg-icon icon-class="like" class-name="icon-like"></svg-icon>
                                <span>{{ like }}</span>
                            </div>
                            <div class="wdc-head__action-item">
                                <svg-icon icon-class="collected" class-name="icon-collect-btn"></svg-icon>
                                <span>{{ collect }}</span>
                            </div>
                        </div>
                        <div class="wdc-head__date">{{ createTime }}</div>
                    </div>
                    <div class="works-detail__content-body">
                        <div class="introduction">
                            {{ introduction }}
                        </div>
                        <div class="content" v-if="videoList && videoList.length > 0">
                            <video v-for="video in videoList" :src="video" :key="video" controls controlsList="nodownload"></video>
                        </div>
                        <div class="content">
                            <img v-for="(picture, index) in pictureList" v-lazy="picture.address" :key="index" @click="handleImage(index)" @contextmenu.prevent="forbidden">
                        </div>
                    </div>
                    <div class="works-detail__content-foot">
                        <div class="wdc-foot__btns">
                            <div class="wdc-foot__btns-btn" @click="toggleLike">
                                <svg-icon icon-class="like-btn" class-name="icon-like-btn" v-if="!isLike"></svg-icon>
                                <div v-else>
                                    <svg-icon icon-class="like-btn1" class-name="icon-like-btn1"></svg-icon>
                                    <span class="num">{{ like }}</span>
                                </div>
                            </div>
                            <div class="wdc-foot__btns-btn" @click="toggleCollect">
                                <svg-icon icon-class="collected" class-name="icon-collect-btn" v-if="!isCollect"></svg-icon>
                                <div v-else>
                                    <svg-icon icon-class="collected" class-name="icon-collect-btn active"></svg-icon>
                                    <span class="num">{{ collect }}</span>
                                </div>
                            </div>
                            <div class="wdc-foot__btns-btn" id="copyUrl" ref="copyUrl" data-clipboard-action="copy" data-clipboard-target="#copyUrl" @click="copyurl">
                                <svg-icon icon-class="forward-btn" class-name="icon-forward-btn"></svg-icon>
                            </div>
                        </div>
                    </div>
                </main>
                <div class="more-works">
                    <div class="user-card" v-if="user">
                        <div class="user-card__avatar" @click="openUserDetail(user.id)">
                            <img :src="user.imageAddress || avatarUrl" />
                        </div>
                        <div class="user-card__info">
                            <div class="user-card__info-name">{{ user.name || '无名大师' }}</div>
                            <div class="user-card__info-area">{{ user.cityName }}</div>
                            <el-button v-if="!isOwner" :type="isFollow ? '' : 'primary'" size="small" class="user-card__info-follow" @click="toggleFollow">
                                {{ isFollow ? '取消关注' : '关注' }}
                            </el-button>
                            <router-link v-else to="/upload/works">
                                <el-button type="primary" size="small" class="user-card__info-follow">开始创作</el-button>
                            </router-link>
                        </div>
                    </div>
                    <div class="more-works__list">
                        <div class="more-works__list-item" v-for="(item, index) in userWorkList" :key="index" @click="openDetail(item.id)">
                            <img :src="item.logo" />
                        </div>
                    </div>
                </div>
                <comment v-if="id" :type="sourceType" :source-id="id" :total-num="commentCount || 0" ref="comment"></comment>
            </div>
            <div class="aside">
                <div class="aside-item user-card" v-if="user">
                    <div class="user-card__avatar" @click="openUserDetail(user.id)">
                        <img :src="user.imageAddress || avatarUrl" />
                    </div>
                    <div class="user-card__info">
                        <div class="user-card__info-name">{{ user.name || '无名大师' }}</div>
                        <div class="user-card__info-area">{{ user.cityName }}</div>
                        <el-button v-if="!isOwner" :type="isFollow ? '' : 'primary'" size="small" class="user-card__info-follow" @click="toggleFollow">{{ isFollow ? '取消关注' : '关注' }}</el-button>
                        <router-link v-else to="/upload/works">
                            <el-button type="primary" size="small" class="user-card__info-follow">开始创作</el-button>
                        </router-link>
                    </div>
                </div>
                <aside-card class="aside-item" circle-color="purple"></aside-card>
                <aside-banner class="aside-item"></aside-banner>
            </div>
        </div>
        <img-dialog-show 
            ref="imgDialog" 
            :img-dialog-show.sync="imgDialogShow" 
            @closeOrg="imgDialogShow = false"  
            :img-url-arr="pictureList" 
            :img-index="index"
        />
        <!-- <div 
			v-if="imgDialogShow"
			class="shadow" >
            <div class="shadow-content">
                <div class="shadow-content-img" v-clickoutside="() => imgDialogShow=false">
                    <img :src="imgDialogUrl" ref="imgDetailRef" alt="" @load="checkHeight($event)"/>
                    <span @click="() => imgDialogShow=false">×</span>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ImgDialogShow from '@/components/ImgDialogShow';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { openWindow } from '@/utils/utils';
import {
    getWorkDetail,
    getUserWorkList,
    viewZuoPin,
    zanZuoPin,
    cancleZanZuoPin,
    isZanZuoPin,
    collectZuoPin,
    cancleCollectZuoPin,
    isCollectZuoPin
} from '@/api/works';
import {
    isAttentionUser,
    attentionUser,
    unAttentionUser
} from '@/api/user';
import { getBannerURL } from '@/api/common';
import AsideCard from '@/views/components/AsideCard';
import AsideBanner from '@/views/components/AsideBanner';
import Comment from '@/components/Comment/Index';

export default {
    name: 'WorksDetail',
    components: {
        AsideCard,
        Comment,
        AsideBanner,
        ImgDialogShow
    },
    inject: ['checkToken', 'reload'],
    data: () => ({
        disabled: false, // 翻页键是否被禁用   1 左翻页被禁用  2右翻页被禁用
        sourceType: 1, // 评论对象类型（1作品 2经验 3社区主题）
        commentCount: 0,
        materialId:'',
        id: null,
        user: null,
        title: '',
        createTime: '',
        content: '',
        follow: 0,
        collect: 0,
        like: 0,
        introduction: '',
        videoList: [],
        pictureList: [],
        isLike: false,
        isCollect: false,
        avatarUrl: '/static/images/user.png',
        userWorkList: [],
        isFollow: false,
        copyBtn: null,
        recommend: null,
        imgDialogShow: false,
        index: 0,
        banner: []
    }),
    computed: {
        ...mapState('user', ['userInfo']),
        isOwner() {
            let isOwner = false;
            if (this.userInfo && this.user && this.userInfo.id === this.user.id) {
                isOwner = true;
            }
            return isOwner;
        }
    },
    watch: {
        userInfo() {
            this.isZanZuoPin();
            this.isCollectZuoPin();
        },
    },
    mounted() {
        const { id } = this.$route.params;
        if (!id) {
            this.$router.push({ name: 'Works' });
            return;
        }
        this.id = id;
        this.getBannerURL()
        this.getDetail();

        this.copyBtn = new this.clipboard(this.$refs.copyUrl, {
            text: () => {
                return window.location.href;
            }
        });
    },
    methods: {
        openBanner(imgUrl) {
            window.open(imgUrl);
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(2).then(({ data }) => {
                this.banner = (data || []).splice(0,2);
            });
        },
        forbidden() {
            return false;
        },
        viewZuoPin() {
            viewZuoPin({ id: this.id });
        },
        isZanZuoPin() {
            if (this.userInfo) {
                isZanZuoPin({ zId: this.id, userId: this.userInfo.id}).then(({ code, data }) => {
                    if (code === 0) {
                        this.isLike = data;
                    }
                });
            }
        },
        isCollectZuoPin() {
            if (this.userInfo) {
                isCollectZuoPin({ zId: this.id, userId: this.userInfo.id}).then(({ code, data }) => {
                    if (code === 0) {
                        this.isCollect = data;
                    }
                });
            }
        },
        isAttentionUser() {
            if (this.userInfo && this.user) {
                isAttentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code, data }) => {
                    if (code === 0) {
                        this.isFollow = data;
                    }
                });
            }
        },
        async getDetail() {
            try {
                const { code, data } = await getWorkDetail({ id: this.id });
                if (code === 0) {
                    this.title = data.title;
                    this.createTime = moment(data.createTime).format('YYYY-MM-DD');
                    this.content = data.htmlContent;
                    this.follow = data.viewCount;
                    this.like = data.zanCount;
                    this.collect = data.collectionCount;
                    this.videoList = data.videoList;
                    this.pictureList = data.pictureList;
                    this.introduction = data.introduction;
                    this.user = data.user;
                    this.recommend = data.recommend;
                    this.commentCount = data.commentCount;
                    this.materialId = data.materialId;

                    this.viewZuoPin();
                    this.isZanZuoPin();
                    this.isCollectZuoPin();

                    if (data.user && !this.isOwner) {
                        this.getUserWork(data.user.id);
                        this.isAttentionUser();
                    }

                    document.title = data.title; //修改页面title
                }
            } catch (e) {
                this.$router.push({ name: 'Works' });
                throw e;
            }
        },
        getUserWork(publisher) {
            getUserWorkList({ publisher , pageNum: 1, pageSize: 4 }).then(({ code, data }) => {
                if (code === 0) {
                    this.userWorkList = data.result;
                }
            });
        },
        toggleLike: debounce(function (){
            if (this.checkToken()) {
                if (!this.isLike) {
                    zanZuoPin({ zId: this.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.like++;
                            this.$message.success('点赞成功');
                            this.isLike = true;
                        }
                    });
                } else {
                    cancleZanZuoPin({ zId: this.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.like--;
                            this.$message.success('已取消点赞');
                            this.isLike = false;
                        }
                    });
                }
            }
        }, 300),
        toggleCollect: debounce(function (){
            if (this.checkToken()) {
                if (!this.isCollect) {
                    collectZuoPin({ zId: this.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.collect++;
                            this.$message.success('收藏成功');
                            this.isCollect = true;
                        }
                    });
                } else {
                    cancleCollectZuoPin({ zId: this.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.collect--;
                            this.$message.success('已取消收藏');
                            this.isCollect = false;
                        }
                    });
                }
            }
        }, 300),
        toggleFollow: debounce(function (){
            if (this.checkToken()) {
                if (!this.isFollow) {
                    attentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.$message.success('关注成功');
                        }
                    }).finally(() => {
                        this.isFollow = true;
                    });
                } else {
                    unAttentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.$message.success('已取消关注');
                        }
                    }).finally(() => {
                        this.isFollow = false;
                    });
                }
            }
        }, 300),
        copyurl() { 
            const clipboard = this.copyBtn;
            clipboard.on('success', () => {
                this.$message.success('已将分享链接复制到剪贴板');
            });
            clipboard.on('error', () => {
                this.$message.error('复制失败，请手动选择复制链接分享！');
            });
        },
        openDetail(id) {
            openWindow('/#/works/detail/' + id);
        },
        openUserDetail(id) {
            this.$router.push({
                name: 'User',
                params: { id }
            });
        },
        handleImage(i) {
            this.imgDialogShow = true;
            this.index = i;
            this.$nextTick(() => {
				this.$refs.imgDialog.handleClickImgOrg()
			})
        }
    }
};
</script>

<style lang="scss" scoped>
.icon-collect-btn {
    vertical-align: middle !important;
    color: #bfbfbf;
}
.detail-wrapper {
    display: flex;
    flex-direction: column;
    &-banner {
		text-align: center;
		font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
		> img {
			cursor: pointer;
			flex: 1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
			font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
		}
	}
    &-body {
        margin: 0 auto;
        padding-top: 20px;
        display: flex;
    }
    .user-card {
        width: 300px;
        height: 162px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background: #fff;
        border-radius: 10px;
        &__avatar {
            width: 94px;
            height: 94px;
            margin-right: 20px;
            cursor: pointer;

            img {
                width: 94px;
                height: 94px;
                border-radius: 50%;
            }
        }

        &__info {
            max-width: 55%;
            &-name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                @include font(rgba(39, 44, 64, 1), 16px, 600);
            }

            &-area {
                @include font(rgba(102, 105, 116, 1), 14px, 400);
            }

            &-follow {
                width: 95px;
                margin-top: 10px;
            }
        }
    }

    .works-detail {
        width: 1000px;

        &__content {
            background-color: rgba(255, 255, 255, 1);
            border-radius: 10px;
            padding: 0 30px;

            &-head {
                padding-top: 30px;
                padding-bottom: 10px;
                border-bottom: 1px solid rgba(236, 237, 255, 1);
                position: relative;

                .wdc-head__title {
                    display: flex;
                    align-items: center;
                    @include font(rgba(39, 44, 64, 1), 22px, 600);

                    span {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        flex: 1;
                    }

                    &-tag {
                        .icon-recommend0,
                        .icon-recommend1,
                        .icon-recommend2 {
                            font-size: 22px;
                            margin-right: 10px;
                        }
                    }
                    .to-material {
                        width: 137px;
                        height: 34px;
                        border-radius: 4px 4px 4px 4px;
                        opacity: 1;
                        border: 1px solid #FF8F1F;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #FF8F1F;
                        font-size: 16px;
                        font-weight: 400;
                        cursor: pointer;
                        img {
                            width: 20px;
                            height: 20px;
                        }
                        &:hover {
                            background: #FFEBD7
                        }
                    }   
                }

                .wdc-head__action {
                    @include font(rgba(145, 145, 145, 1), 14px, 400);
                    margin-top: 15px;
                    display: flex;

                    &-item {
                        margin-right: 30px;
                        .icon-follow,
                        .icon-collect,
                        .icon-like {
                            margin-right: 5px;
                            color: rgba(191, 191, 191, 1);
                        }
                    }
                }

                .wdc-head__date {
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    @include font(rgba(145, 145, 145, 1), 14px, 400);
                }
            }

            &-body {
                padding: 20px 0;
                overflow: hidden;
                width: 900px;
                margin: 0 auto;

                .introduction {
                    max-width: 700px;
                    margin: 0 auto 20px;
                    line-height: 24px;
                    @include font(#272c40, 16px, 400);
                }

                img, video {
                    display: block;
                    margin: 0 auto;
                    max-width: 900px;
                    cursor: pointer;
                    box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
                }
                video {
                    margin-bottom: 30px;
                }
            }

            &-foot {
                height: 130px;
                border-top: 1px solid rgba(236, 237, 255, 1);
                display: flex;
                align-items: center;
                justify-content: center;

                .wdc-foot__btns {
                    display: flex;
                    justify-content: space-between;
                    width: 210px;
                    height: 50px;

                    &-btn {
                        position: relative;
                        width: 50px;
                        height: 50px;
                        cursor: pointer;

                        .num {
                            position: absolute;
                            top: 28px;
                            left: 50%;
                            transform: translate(-50%, 0);
                            @include font(rgba(255, 255, 255, 1), 12px, 400);
                        }

                        .icon-like-btn,
                        .icon-collect-btn,
                        .icon-forward-btn,
                        .icon-like-btn1,
                        .icon-collect-btn1,
                        .icon-forward-btn1 {
                            font-size: 50px;
                            transition: color 0.3s;
                        }

                        .icon-like-btn1,
                        .icon-collect-btn1,
                        .icon-forward-btn1 {
                            color: rgba(191, 191, 191, 1);
                            &:hover {
                                color: rgba(191, 191, 191, 0.8);
                            }
                        }

                        .icon-like-btn {
                            color: rgba(232, 76, 130, 1);

                            &:hover {
                                color: rgba(232, 76, 130, 0.8);
                            }
                        }
                        .icon-collect-btn {
                            padding: 15px;
                            background-color: rgba(47, 84, 235, 1);
                            color: #fff;
                            font-size: 20px;

                            &:hover {
                                background-color: rgba(47, 84, 235, 0.8);
                                color: #fff;
                            }
                            
                            &.active {
                                padding: 10px 17px 24px 17px;
                                background-color: #bfbfbf;
                                font-size: 16px;
                            }
                        }
                        .icon-forward-btn {
                            color: rgba(0, 172, 188, 1);

                            &:hover {
                                color: rgba(0, 172, 188, 0.8);
                            }
                        }
                    }
                }
            }
        }

        .more-works {
            height: 162px;
            margin-top: 20px;
            background-color: rgba(255, 255, 255, 1);
            border-radius: 10px;
            display: flex;
            align-items: center;
            padding-right: 30px;

            &__user {
                width: 300px;
            }

            &__list {
                width: 700px;
                height: 120px;
                display: flex;

                &-item {
                    width: 171px;
                    height: 120px;
                    border: 1px solid rgba(224, 228, 247, 1);
                    border-radius: 6px;
                    cursor: pointer;
                    overflow: hidden;

                    &:hover img {
                        transform: scale(1.05);
                    }

                    img {
                        width: 171px;
                        height: 120px;
                        border-radius: 6px;
                        transition: transform 0.35s;
                    }

                    &:not(:first-child) {
                        margin-left: 20px;
                    }
                }
            }
        }
    }

    .aside {
        width: 300px;
        margin-left: 20px;

        &-item:not(:first-child) {
            margin-top: 20px;
        }
    }

    .img-dialog{
        >.el-dialog__body{
            overflow: auto;
        }
    }
}

// 小屏
@include mq($small) {
    .detail-wrapper {
        .user-card {
            width: 225px;
            height: 121px;
            &__avatar {
                width: 72px;
                height: 72px;
                margin-right: 15px;

                img {
                    width: 72px;
                    height: 72px;
                }
            }

            &__info {
                &-name {
                    @include font(rgba(39, 44, 64, 1), 14px, 600);
                }

                &-area {
                    @include font(rgba(102, 105, 116, 1), 12px, 400);
                }

                &-follow {
                    width: 72px;
                    padding: 10px;
                    margin-top: 10px;
                }
            }
        }

        .works-detail {
            width: 800px;

            &__content {
                padding: 0 22px;

                &-head {
                    padding-top: 22px;
                    padding-bottom: 10px;

                    .wdc-head__title {
                        @include font(rgba(39, 44, 64, 1), 20px, 600);

                        &-tag {
                            .icon-recommend0,
                            .icon-recommend1,
                            .icon-recommend2 {
                                font-size: 20px;
                                margin-right: 10px;
                            }
                        }
                    }

                    .wdc-head__action {
                        @include font(rgba(145, 145, 145, 1), 12px, 400);
                        margin-top: 12px;

                        &-item {
                            margin-right: 22px;
                        }
                    }

                    .wdc-head__date {
                        @include font(rgba(145, 145, 145, 1), 12px, 400);
                    }
                }

                &-body {
                    padding: 15px 8px;
                    img,video {
                        // min-width: 885px;
                        max-width: 100%;
                    }
                }

                &-foot {
                    height: 93px;
                }
            }

            .more-works {
                height: 121px;
                margin-top: 15px;

                &__user {
                    width: 225px;
                }

                &__list {
                    width: 730px;
                    height: 90px;
                    display: flex;

                    &-item {
                        width: 135px;
                        height: 90px;

                        img {
                            width: 142px;
                            height: 90px;
                        }

                        &:not(:first-child) {
                            margin-left: 12px;
                        }
                    }
                }
            }
        }

        .aside {
            width: 225px;
            margin-left: 18px;
        }
    }
}
@media screen and (min-width: 1366px) and (max-width: 1919px) {
    /* 在1366px到1920px分辨率范围内生效的样式 */
    .detail-wrapper {
        .works-detail {
            width: 800px;
            &__content {
                &-body {
                    width:700px;
                    .content {
                        img, video {
                            max-width:700px;
                        }
                    }
                }
            }
        }
    }
}
</style>
